import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { AuthProvider } from "react-oidc-context";
import App from "@View/App";
import StoreProvider from "@View/providers/StoreProvider";
import ThemeProvider from "@View/providers/ThemeProvider";
import GlobalStyles from "@View/style/GlobalStyles";
import Loader from "@View/components/loader/Loader";
import { createOidcConfig } from "./sso/keycloak";
import {
  IsYaMetricEnabled,
  loadRuntimeConfig,
  SHOULD_USE_KEYCLOAK_AUTH,
  IsSupportChatEnabled
} from "@Constants/tokens";
import { AlertProvider } from "@View/components/ui/alert/alert-context";

const bootstrap = () => {
  if (IsYaMetricEnabled()) {
    const script = document.createElement("script");
    script.textContent = ` 
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  
      ym(96494516, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
    `;
    document.body.appendChild(script);
  }

  if (IsSupportChatEnabled()) {
    const b24Style = document.createElement('style');
    b24Style.textContent = '.b24-widget-button-pulse { display: none; }';
    document.head.appendChild(b24Style);

    const b24Script = document.createElement('script');
    b24Script.textContent = `
    (function(w,d,u){
            var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
            var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
    })(window,document,'https://cdn-ru.bitrix24.ru/b24516680/crm/site_button/loader_4_9anrm9.js');
    `;
    document.body.appendChild(b24Script);
  }

  let renderApp = (
    <StoreProvider>
      <Suspense fallback={<Loader />}>
        <ThemeProvider>
          <AlertProvider>
            <GlobalStyles />
            <App />
          </AlertProvider>
        </ThemeProvider>
      </Suspense>
    </StoreProvider>
  );
  if (SHOULD_USE_KEYCLOAK_AUTH()) {
    renderApp = <AuthProvider {...createOidcConfig()}>{renderApp}</AuthProvider>;
  }

  ReactDOM.render(renderApp, document.getElementById("root"));
};

loadRuntimeConfig()
  .then(() => {
    bootstrap();
  })
  .catch((e) => {
    console.error("Runtime config loading error");
    console.error(e);
  });
